import { ApolloClient } from 'apollo-client';
import { InMemoryCache } from 'apollo-cache-inmemory';
import { from } from 'apollo-link';
import { auth, http } from './links';
import authorizationGql from '../../utils/authorization.gql';
import condominiumContextGql from '../../utils/condominium-context.gql';

const ssrMode = typeof window === 'undefined';

export default function createClient(request) {
  const link = from([auth(request), http(request)]);

  const client = new ApolloClient({
    ssrMode,
    link,
    cache: ssrMode ? new InMemoryCache() : new InMemoryCache().restore(window.__APOLLO_STATE__),
    resolvers: {
      Query: {
        authorization: (_, args, { cache }) => {
          try {
            return cache.readQuery(authorizationGql);
          } catch (e) {
            return null;
          }
        },
        condominiumContextQuery: (_, args, { cache }) => {
          try {
            return cache.readQuery(condominiumContextGql);
          } catch (e) {
            return null;
          }
        },
      },
    },
  });

  return client;
}
